import React from 'react';
import './Benefits.scss';
import LinkButton from '../LinkButton/LinkButton';

const Benefits = ({ title, subtitle, list, button }) => (
	<div className='benefits-container'>
		<div className='row padded-row'>
			<div className='col-12 col-md-5 col-lg-4 benefits-left'>
				{typeof title !== 'undefined' && (
					<h1 className='benefits-title'>
						{title}
						<i className='fas fa-circle html-period'></i>
					</h1>
				)}
				{typeof subtitle !== 'undefined' && <h4 className='text-white'>{subtitle}</h4>}
				{typeof button === 'undefined' ? (
						<div>
							<LinkButton
								color='green'
								text='Speak With Us'
								linkSrc='https://landing.dochq.co.uk/video-call/'
							/>
						</div>
					) : (
						<div>{button}</div>
					)}
			</div>
			<div className='col-12 col-md-7 col-lg-8 row benefits-right' style={{margin: 'auto'}}>
						{list.map((item, i) => (
							<h4 key={i}>{item}</h4>
						))}
			</div>
		</div>
	</div>
);

export default Benefits;
